function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6727 9H9.32722C8.15244 9 7.19995 9.8955 7.19995 11V19C7.19995 20.1045 8.15244 21 9.32722 21H20.6727C21.8475 21 22.8 20.1045 22.8 19V11C22.8 9.8955 21.8475 9 20.6727 9ZM20.6727 10.3333C20.754 10.3333 20.831 10.3488 20.9037 10.3725L15 14.8128L9.09624 10.3725C9.1691 10.3488 9.24586 10.3333 9.32722 10.3333H20.6727ZM20.6727 19.6667H9.32722C8.93545 19.6667 8.61813 19.3683 8.61813 19V11.7205L14.5569 16.1872C14.6864 16.2847 14.8432 16.3333 15 16.3333C15.1567 16.3333 15.3135 16.2847 15.443 16.1872L21.3818 11.7205V19C21.3818 19.3683 21.0645 19.6667 20.6727 19.6667Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 14,
  stroke: "white",
  strokeWidth: 2
});

var SvgIconMail2 = function SvgIconMail2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMail2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-mail2.0aa2cd8f.svg";
export { ForwardRef as ReactComponent };